import type { VoidFunctionComponent } from 'react';

import useRevisionLicense from '../../../../../../hooks/api/licenses/useRevisionLicense';

type Props = {
  licenseId: string;
  dependencyLocator: string;
  revisionLicenseId: number;
};

const CustomLicenseName: VoidFunctionComponent<Props> = ({ licenseId, dependencyLocator, revisionLicenseId }) => {
  const { data: revisionLicense } = useRevisionLicense(dependencyLocator, revisionLicenseId);

  const title =
    revisionLicense?.name && revisionLicense.name !== licenseId ? `${revisionLicense.name} (${licenseId})` : licenseId;
  return <div>{title}</div>;
};

export default CustomLicenseName;
